import CameraAltIcon from '@mui/icons-material/CameraAlt';
import ButtonBase, { ButtonBaseProps } from '@mui/material/ButtonBase';
import Grid, { GridProps as MuiGridProps } from '@mui/material/Grid';
import { useTheme } from '@mui/material/styles';
import React from 'react';
import SmartImage from './SmartImage';

export interface IAvatarPlaceholder extends ButtonBaseProps {
  size: number;
  GridProps?: MuiGridProps;
  btn?: boolean
}

function AvatarInner(props: IAvatarPlaceholder) {
  const { size, GridProps } = { GridProps: {} as MuiGridProps, ...props };
  return (
    <Grid
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
      {...GridProps}
      sx={{
        backgroundColor: '#F2F3F2',
        borderRadius: '50%',
        width: (theme) => theme.spacing(size),
        height: (theme) => theme.spacing(size),
        ...(GridProps.sx ? GridProps.sx : {})
      }}
    >
      <CameraAltIcon
        sx={{
          color: '#BEBDBD',
          width: (theme) => theme.spacing(size - 12),
          height: (theme) => theme.spacing(size - 12)
        }}
      />
    </Grid>
  );
}


export default function AvatarPlaceholder(props: IAvatarPlaceholder) {
  const { onClick } = props;
  if (onClick) {
    return (
      <ButtonBase
        {...props}
        sx={{
          ...(props.sx ? props.sx : {}),
          borderRadius: '50%'
        }}
      >
        <AvatarPlaceholder {...props}/>
      </ButtonBase>
    );
  } else {
    return (
      <AvatarInner {...props}/>
    );
  }
}

function DogAvatarInner(props: IAvatarPlaceholder) {
  const { size, GridProps } = { GridProps: {} as MuiGridProps, ...props };
  const myTheme = useTheme();
  return (
    <Grid
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
      {...GridProps}
      sx={{
        // backgroundColor: '#F2F3F2',
        // borderRadius: '50%',
        width: (theme) => theme.spacing(size),
        height: (theme) => theme.spacing(size),
        ...(GridProps.sx ? GridProps.sx : {})
      }}
    >
      <SmartImage
        src={`${process.env.PUBLIC_URL}/assets/SVG/dog.svg`}
        style={{
          width: myTheme.spacing(size),
          height: myTheme.spacing(size)
        }}
      />
    </Grid>
  );
}

export function DogAvatarPlaceholder(props: IAvatarPlaceholder) {
  const { onClick } = props;
  if (onClick) {
    return (
      <ButtonBase
        {...props}
        sx={{
          ...(props.sx ? props.sx : {}),
          borderRadius: '50%'
        }}
      >
        <DogAvatarPlaceholder {...props}/>
      </ButtonBase>
    );
  } else {
    return (
      <DogAvatarInner {...props}/>
    );
  }

}
